import React, { useState} from "react";
import Modal from "react-bootstrap/Modal";
import NguonKhachHangApi from "service/nguonKhachHangApi";
import { pushNotification } from "utils/notifications";

export const ModalXoa = ({ show, onHide, onDeleted, item, dbName }) => {
    const [isSubmit, setIsSubmit] = useState(false);

    const handleDeleteConfirm = () => {
        setIsSubmit(true);
        NguonKhachHangApi.delete(item.NguonKH_ID, dbName)
            .then(res => {
                if (res.status === 200) {
                    pushNotification("Xóa thành công!", "success");
                    onDeleted();
                } else {
                    pushNotification(res.data?.Message || "Lỗi: Không thể xoá.", "error");
                    onHide();
                }
            })
            .catch(err => {
                pushNotification(err?.response?.data || "Lỗi: Không thể xoá.", "error");
                onHide();
            })
            .finally(() => {
                setIsSubmit(false);
            });
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left"
        >
            <Modal.Header>
                <h4 className="modal-title color7-bold ml-1">
                    Xác nhận xóa
                </h4>
                <button type="button" className="close-popup-new" onClick={onHide}>
                    <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                </button>
            </Modal.Header>
            <Modal.Body className="">
                <p>Bạn có chắc muốn xóa nguồn khách hàng: <strong>"{item?.TenNguonKH}"</strong>?</p>
                <p className="text-danger">Hành động này không thể hoàn tác.</p>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-new-main btn-closenew"
                    onClick={onHide}
                >
                    <span><i className="mdi mdi-close"></i></span>&nbsp; Đóng
                </button>
                <button 
                    type="button" 
                    className="btn btn-new-main btn-danger"
                    onClick={handleDeleteConfirm}
                    disabled={isSubmit}
                >
                    <span><i className="la la-trash"></i></span>&nbsp; {isSubmit ? "Đang xóa..." : "Xác nhận xóa"}
                </button>
            </Modal.Footer>
        </Modal>
    );
}